export const WNG_TRACKING_NOT_SENT_HTML_EVENT_ID =
  "Html Event Tracking: not sent as there is not html-event-id.";
export const WNG_HTML_EVENT_ID_PROP_DEPRECATED =
  'Html Event Tracking: In the next version, this HOC will not accept the html-event-id as a parameter. Instead, you will have to add it as a "html-event-id" prop of the wrapped component.';
export const WNG_NO_WITH_MODULE_CONTEXT =
  "Html Event Tracking: tracked components needs to be wrapped withModuleContext.";
